import React from 'react';

const ShowcaseDetailsSection = ({ formData, handleNestedChange, API_BASE_URL }) => {
  const sd = formData.showcaseDetails || {};
  const ba = sd.beforeAfter || {};

  const handleUpload = async (field) => {
    const input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/jpeg,image/png,image/gif,image/webp,image/svg+xml';
    input.onchange = async (e) => {
      const file = e.target.files?.[0];
      if (!file) return;
      const fd = new FormData();
      fd.append('image', file);
      try {
        const resp = await fetch(`${API_BASE_URL}/api/upload`, { method: 'POST', body: fd });
        if (resp.ok) {
          const result = await resp.json();
          const fullUrl = result.url.startsWith('http') ? result.url : `${API_BASE_URL}${result.url}`;
          handleNestedChange(`showcaseDetails.beforeAfter.${field}`, fullUrl);
        }
      } catch (err) {
        console.error('Upload failed:', err);
      }
    };
    input.click();
  };

  return (
    <div className="form-section">
      <h3>Showcase Details</h3>
      <p className="text-muted">Only used for showcase-type products.</p>

      <div className="form-group">
        <label>Client</label>
        <input
          type="text"
          className="form-control"
          value={sd.client || ''}
          onChange={(e) => handleNestedChange('showcaseDetails.client', e.target.value)}
          placeholder="Client name"
        />
      </div>

      <div className="form-group">
        <label>Results</label>
        <textarea
          className="form-control"
          rows="3"
          value={sd.results || ''}
          onChange={(e) => handleNestedChange('showcaseDetails.results', e.target.value)}
          placeholder="Key results and outcomes"
        />
      </div>

      <div className="form-group">
        <label>Timeline</label>
        <input
          type="text"
          className="form-control"
          value={sd.timeline || ''}
          onChange={(e) => handleNestedChange('showcaseDetails.timeline', e.target.value)}
          placeholder="e.g. 3 months"
        />
      </div>

      <div className="form-group">
        <label>Testimonial</label>
        <textarea
          className="form-control"
          rows="3"
          value={sd.testimonial || ''}
          onChange={(e) => handleNestedChange('showcaseDetails.testimonial', e.target.value)}
          placeholder="Client testimonial quote"
        />
      </div>

      <div className="form-group">
        <label className="checkbox-label">
          <input
            type="checkbox"
            checked={ba.enabled || false}
            onChange={(e) => handleNestedChange('showcaseDetails.beforeAfter.enabled', e.target.checked)}
          />
          Show Before/After Images
        </label>
      </div>

      {ba.enabled && (
        <div className="form-row">
          <div className="form-group">
            <label>Before Image</label>
            <div className="image-upload-row">
              <input
                type="text"
                className="form-control"
                value={ba.beforeImage || ''}
                onChange={(e) => handleNestedChange('showcaseDetails.beforeAfter.beforeImage', e.target.value)}
                placeholder="Image URL"
              />
              <button
                type="button"
                className="btn btn-sm btn-outline"
                onClick={() => handleUpload('beforeImage')}
              >
                Upload
              </button>
            </div>
            {ba.beforeImage && (
              <img src={ba.beforeImage} alt="Before" className="image-preview" style={{ maxWidth: '150px', marginTop: '4px' }}
                onError={(e) => { e.target.style.display = 'none'; }} />
            )}
          </div>
          <div className="form-group">
            <label>After Image</label>
            <div className="image-upload-row">
              <input
                type="text"
                className="form-control"
                value={ba.afterImage || ''}
                onChange={(e) => handleNestedChange('showcaseDetails.beforeAfter.afterImage', e.target.value)}
                placeholder="Image URL"
              />
              <button
                type="button"
                className="btn btn-sm btn-outline"
                onClick={() => handleUpload('afterImage')}
              >
                Upload
              </button>
            </div>
            {ba.afterImage && (
              <img src={ba.afterImage} alt="After" className="image-preview" style={{ maxWidth: '150px', marginTop: '4px' }}
                onError={(e) => { e.target.style.display = 'none'; }} />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ShowcaseDetailsSection;
